import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import {
  Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import ROUTES from '../../../config/routes';

import { getBranchesOptions } from '../../../app/store/actions/branches';
import { getSupplierOptions } from '../../../app/store/actions/suppliers';
import { getOrdersTypeOptions } from '../../../app/store/actions/typeOrder';
import { getCarriersOptions } from '../../../app/store/actions/carriers';
import { getUnitsMeasureOptions } from '../../../app/store/actions/unitsMeasure';
import OneClickButton from '../../../components/form/button';
import addNotification from '../../../components/notification';
import { PanelPage } from '../../../components/pages/pages';
import WikiHelp from '../../../components/tooltip/wikiHelp';
import {
  createManualRequest,
  getManualRequestOptions,
  getManualRequestOptionsProducts,
} from '../../../app/store/actions/inboundManualRequest';
import Table from '../../../components/table/Table';
import FormatHelpers from '../../../helpers/format';
import Form from '../../../components/form/form';
import getAddressByCep from '../../../app/services/viaCep';
import { setJsonContent } from '../../../app/store/actions/bulkImport';
import {
  Panel, PanelBody, PanelFooter, PanelHeader,
} from '../../../components/panel/panel';
import DragAndDrop from '../../../components/bulkImport/DragAndDrop';
import ImportCaption from '../../../components/bulkImport/ImportCaption';
import { bulkImportInboundOrder, openBulkImportInboundOrder } from '../../../app/store/actions/inboundOrders';

class InboundOrderAdd extends React.Component {
  constructor(props) {
    super(props);

    this.pageSize = 10;

    this.state = {
      activeTab: '1',
      branchCode: '',
      branchName: '',
      supplierCode: '',
      supplierName: '',
      orderNumber: '',
      orderTypeCode: '',
      orderTypeName: '',
      cfop: '',
      specie: '',
      serie: '',
      accessKey: '',
      canceled: false,
      note: '',
      carrierCode: '',
      carrierName: '',
      licensePlate: '',
      expectedVolumes: '',
      postalCode: '',
      street: '',
      number: '',
      ibge: '',
      complement: '',
      district: '',
      city: '',
      state: '',
      country: '',
      deliveryDate: '',
      productCode: '',
      productName: '',
      supplierProductCode: '',
      quantity: 1,
      productDeliveryDate: '',
      unitMeasureCode: null,
      unitMeasureName: '',
      purchaseRequest: '',
      purchaseOrder: '',
      installment: 1,
      crossDockingOrder: '',
      crossDockingQuantity: '',
      batchNumber: '',
      expirationDate: '',
      productNote: '',
      productsRequest: [],
      listProduct: [],
      disableName: true,
      disableUnitMeasure: false,
    };

    this.defaultSorted = [{
      id: 'lineNumber',
      desc: true,
    }];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => { this.removeProductsRequest(rows.row); }}
              type="button"
            >
              {I18n.t('BEE558' /* Remover */)}
            </button>
          </div>
        ),
      },
      {
        Header: I18n.t('BEE463' /* Linha */),
        accessor: 'lineNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
      },
      {
        Header: I18n.t('BEE378' /* Código do Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 165,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE1043' /* Nome do Produto */),
        accessor: 'productName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3800' /* Cód. Prod. Fornecedor */),
        accessor: 'supplierProductCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 165,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3799' /* UN */),
        accessor: 'unitMeasure',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3801' /* QTD */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 75,
        Filter: this.filterColumn,
        Cell: (row) => (
          <span>
            {FormatHelpers.formatNumber(row.value ? row.value : 0, 4, false)}
          </span>
        ),
      }, {
        Header: I18n.t('BEE444' /* Data de Entrega */),
        accessor: 'productDeliveryDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
        Filter: this.filterColumn,
        Cell: (row) => (
          <span>
            {FormatHelpers.formatDate(row.value)}
          </span>
        ),
      }, {
        Header: I18n.t('BEE3787' /* Solicitação de Compra */),
        accessor: 'purchaseRequest',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 165,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3789' /* Ordem de Compra */),
        accessor: 'purchaseOrder',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 165,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3791' /* Parcela */),
        accessor: 'installment',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3794' /* Ordem de Cross-Docking */),
        accessor: 'crossDockingOrder',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3802' /* QTD Cross-Docking */),
        accessor: 'crossDockingQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE1091' /* Número do lote */),
        accessor: 'batchNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE434' /* Data de Validade */),
        accessor: 'expirationDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        Cell: (row) => (
          <span>
            {FormatHelpers.formatDate(row.value)}
          </span>
        ),
      }, {
        Header: I18n.t('BEE135' /* Observação */),
        accessor: 'productNote',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
      }];

    this.csvPreviewTable = [
      // branchCode
      {
        Header: I18n.t('BEE409' /* Código da Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 125,
      },
      // supplierCode
      {
        Header: I18n.t('BEE3919' /* Código do fornecedor */),
        accessor: 'supplierCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 165,
      },
      // orderNumber
      {
        Header: I18n.t('BEE1124' /* Número do Pedido */),
        accessor: 'orderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 145,
      },
      // orderType
      {
        Header: I18n.t('BEE2273' /* Tipo do Documento */),
        accessor: 'orderType',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      },
      // serie
      {
        Header: I18n.t('BEE403' /* Série */),
        accessor: 'serie',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
      },
      // especie
      {
        Header: I18n.t('BEE1729' /* Espécie */),
        accessor: 'specie',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 85,
      },
      // accessKey
      {
        Header: I18n.t('BEE967' /* Chave de Acesso */),
        accessor: 'accessKey',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
      },
      // canceled
      {
        Header: I18n.t('BEE64' /* Cancelado */),
        accessor: 'canceled',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 95,
      },
      // carrierCode
      {
        Header: I18n.t('BEE2272' /* Código da Transportadora */),
        accessor: 'carrierCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 190,
      },
      // licensePlate
      {
        Header: I18n.t('BEE400' /* Placa do Veículo */),
        accessor: 'licensePlate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
      },
      // expectedVolumes
      {
        Header: I18n.t('BEE1029' /* Volumes Esperados */),
        accessor: 'expectedVolumes',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      },
      // cfop
      {
        Header: I18n.t('BEE1030' /* CFOP */),
        accessor: 'cfop',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
      },
      // deliveryDate
      {
        Header: I18n.t('BEE444' /* Data de Entrega */),
        accessor: 'deliveryDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
      },
      // postalCode
      {
        Header: I18n.t('BEE1730' /* CEP */),
        accessor: 'postalCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
      },
      // ibge
      {
        Header: I18n.t('BEE568' /* IBGE */),
        accessor: 'ibge',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
      },
      // street
      {
        Header: I18n.t('BEE121' /* Rua */),
        accessor: 'street',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
      },
      // number
      {
        Header: I18n.t('BEE123' /* Número */),
        accessor: 'number',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 85,
      },
      // complement
      {
        Header: I18n.t('BEE125' /* Complemento */),
        accessor: 'complement',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      },
      // district
      {
        Header: I18n.t('BEE127' /* Bairro */),
        accessor: 'district',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
      },
      // city
      {
        Header: I18n.t('BEE53' /* Cidade */),
        accessor: 'city',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 75,
      },
      // state
      {
        Header: I18n.t('BEE87' /* Estado */),
        accessor: 'state',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 75,
      },
      // country
      {
        Header: I18n.t('BEE88' /* País */),
        accessor: 'country',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
      },
      // note
      {
        Header: I18n.t('BEE135' /* Observação */),
        accessor: 'note',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 105,
      },
      // lineNumber
      {
        Header: I18n.t('BEE463' /* Linha */),
        accessor: 'lineNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 70,
      },
      // productCode
      {
        Header: I18n.t('BEE378' /* Código do Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 145,
      },
      // supplierProductCode
      {
        Header: I18n.t('BEE3786' /* Código do Produto do Fornecedor */),
        accessor: 'supplierProductCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 230,
      },
      // quantity
      {
        Header: I18n.t('BEE441' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 105,
      },
      // productDeliveryDate
      {
        Header: I18n.t('BEE444' /* Data de Entrega */),
        accessor: 'productDeliveryDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
      },
      // unitMeasure
      {
        Header: I18n.t('BEE1756' /* Unidade de Medida */),
        accessor: 'unitMeasure',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 155,
      },
      // purchaseRequest
      {
        Header: I18n.t('BEE3787' /* Solicitação de Compra */),
        accessor: 'purchaseRequest',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 165,
      },
      // purchaseOrder
      {
        Header: I18n.t('BEE3789' /* Ordem de Compra */),
        accessor: 'purchaseOrder',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 145,
      },
      // installment
      {
        Header: I18n.t('BEE3791' /* Parcela */),
        accessor: 'installment',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
      },
      // crossDockingOrder
      {
        Header: I18n.t('BEE3794' /* Ordem de Cross-Docking */),
        accessor: 'crossDockingOrder',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
      },
      // crossDockingQuantity
      {
        Header: I18n.t('BEE3796' /* Quantidade de Cross-Docking */),
        accessor: 'crossDockingQuantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 210,
      },
      // productNote
      {
        Header: I18n.t('BEE3925' /* Observação do produto */),
        accessor: 'productNote',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
      },
      // batchNumber
      {
        Header: I18n.t('BEE1091' /* Número do lote */),
        accessor: 'batchNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
      },
      // expirationDate
      {
        Header: I18n.t('BEE2398' /* Data de Validade */),
        accessor: 'expirationDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 135,
      },
      // Processing file fields
      {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'error.error',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 190,
        sortable: false,
        Cell: (row) => (
          <span>
            {this.renderStatusValue(row.original)}
          </span>
        ),
      }, {
        Header: I18n.t('BEE2521' /* Linha do arquivo */),
        accessor: 'error.line',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        sortable: true,
      }, {
        Header: I18n.t('BEE135' /* Observação */),
        accessor: 'error.message',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 330,
        sortable: false,
      },
    ];

    this.renderStatusValue = (row) => {
      if (row?.error?.error === '') {
        return (
          <span style={{ color: 'green', fontWeight: '700' }}>
            {I18n.t('BEE2523' /* Processado com sucesso */)}
          </span>
        );
      }
      if (row?.error?.error) {
        return <span style={{ color: 'red', fontWeight: '700' }}>{I18n.t('BEE2520' /* Processado com erro */)}</span>;
      }
      if (!row.error) {
        return (
          <span style={{ color: '#F17B1E', fontWeight: '700' }}>
            {I18n.t('BEE2524' /* Aguardando processamento */)}
          </span>
        );
      }
    };
  }

  async componentDidMount() {
    await this.getFormOptions();
    await this.getProductsOptions();
  }

  async componentDidUpdate(prevProps) {
    if ((prevProps.userLogged && prevProps.userLogged.mainBranchData)
    !== (this.props.userLogged && this.props.userLogged.mainBranchData)) {
      await this.getFormOptions();
      await this.getProductsOptions();
    }
  }

  setValue = async (attr, value) => {
    if (attr === 'postalCode') {
      const newPostalCode = value;
      const { postalCode } = this.state;

      if (newPostalCode !== postalCode) {
        this.setState({
          [`${attr}`]: value,
        });

        const re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;

        if (re.test(newPostalCode)) {
          await this.searchViaCep(newPostalCode);
        } else {
          await this.cleanAddress();
        }
      }
    } else if (attr === 'canceled') {
      this.setState({
        [`${attr}`]: !!value,
      });
    } else {
      this.setState({
        [`${attr}`]: value,
      });
    }
  };

  setValueDrop = async (attr, value) => {
    this.setState({
      [`${attr}Code`]: value ? value.value : null,
      [`${attr}Name`]: value ? value.label : '',
    });
  };

  setFilterDrop = _.debounce(async (attr, value) => {
    const {
      productCode,
    } = this.state;

    if (productCode === value) {
      return;
    }

    const { products } = await this.props.getManualRequestOptionsProducts(value, false);

    const dataSelected = products?.filter((item) => item.value === value);

    if (dataSelected.length === 1) {
      this.setState({
        [`${attr}Code`]: dataSelected[0].value ? dataSelected[0].value : null,
        [`${attr}Name`]: dataSelected[0].value ? dataSelected[0].label : '',
        unitMeasureCode: dataSelected[0].value ? dataSelected[0].unitMeasure : null,
        unitMeasureName: dataSelected[0].value ? dataSelected[0].unitMeasure : '',
        disableUnitMeasure: true,
      });
    } else {
      this.setState({
        [`${attr}Code`]: null,
        [`${attr}Name`]: '',
        disableUnitMeasure: false,
        unitMeasureCode: null,
        unitMeasureName: '',
      });
    }

    this.setState({
      listProduct: products,
    });
  }, 1000);

  addProductsRequest = () => {
    const {
      productsRequest,
      productCode,
      productName,
      supplierProductCode,
      quantity,
      productDeliveryDate,
      unitMeasureCode,
      purchaseRequest,
      purchaseOrder,
      installment,
      crossDockingOrder,
      crossDockingQuantity,
      batchNumber,
      expirationDate,
      productNote,
    } = this.state;

    if (!productCode) {
      addNotification(
        'danger',
        I18n.t('BEE3771' /* Documento de Entrada Manual */),
        I18n.t('BEE2454' /* Informe o código do produto */),
        'top-right',
      );
      return;
    } if (!quantity && quantity <= 0) {
      addNotification(
        'danger',
        I18n.t('BEE3771' /* Documento de Entrada Manual */),
        I18n.t('BEE2293' /* A quantidade tem que ser maior que 0 */),
        'top-right',
      );
      return;
    }

    const existProduct = productsRequest.filter((item) => item.productCode === productCode);

    if (existProduct.length > 0) {
      addNotification(
        'danger',
        I18n.t('BEE3771' /* Documento de Entrada Manual */),
        I18n.t('BEE3343', { 0: productCode } /* Produto %{0} já foi adicionado! */),
        'top-right',
      );
      return;
    }

    const supplierProductCodeTemp = supplierProductCode || productCode;

    const lineNumber = productsRequest.length
      ? Number(productsRequest[productsRequest.length - 1].lineNumber) + 10
      : 10;

    const productsRequestTemp = [...productsRequest];

    productsRequestTemp.push({
      lineNumber,
      productCode,
      productName,
      supplierProductCode: supplierProductCodeTemp,
      quantity,
      productDeliveryDate,
      unitMeasure: unitMeasureCode,
      purchaseRequest,
      purchaseOrder,
      installment,
      crossDockingOrder,
      crossDockingQuantity,
      batchNumber,
      expirationDate,
      productNote,
    });

    this.setState({
      productsRequest: productsRequestTemp,
      productCode: null,
      productName: '',
      supplierProductCode: '',
      quantity: 1,
      productDeliveryDate: '',
      unitMeasureCode: null,
      unitMeasureName: '',
      purchaseRequest: '',
      purchaseOrder: '',
      installment: 1,
      crossDockingOrder: '',
      crossDockingQuantity: '',
      batchNumber: '',
      expirationDate: '',
      productNote: '',
      disableUnitMeasure: false,
    });
  };

  removeProductsRequest = (item) => {
    const { productsRequest } = this.state;
    const removeProductsRequest = productsRequest.filter((filter) => filter.lineNumber !== item.lineNumber);

    this.setState({ productsRequest: removeProductsRequest });
  };

  getFormOptions = async () => {
    try {
      const listBranch = await this.props.getBranchesOptions();
      const branchCodeUser = await this.props.userLogged.mainBranch?.branchCode;
      const selectBranch = listBranch.find((element) => element.value === branchCodeUser);

      const listOrderTypes = await this.props.getOrdersTypeOptions();
      const selectOrderType = listOrderTypes.find((element) => element.value === this.state.orderTypeCode);

      const listSuppliers = await this.props.getSupplierOptions();
      const selectSupplier = listSuppliers.find((element) => element.value === this.state.supplierCode);

      const listCarriers = await this.props.getCarriersOptions();
      const selectCarrier = listCarriers.find((element) => element.value === this.state.carrierCode);

      const listUnitMeasure = await this.props.getUnitsMeasureOptions();
      const selectUnitMeasure = listUnitMeasure.find((element) => element.value === this.state.unitMeasure);

      this.setState({
        listBranch: listBranch || [],
        branchCode: selectBranch?.value || null,
        branchName: selectBranch?.label || '',
        listOrderTypes: listOrderTypes || [],
        orderTypeCode: selectOrderType?.value || null,
        orderTypeName: selectOrderType?.label || '',
        listSuppliers: listSuppliers || [],
        supplierCode: selectSupplier?.value || null,
        supplierName: selectSupplier?.label || '',
        listCarriers: listCarriers || [],
        carrierCode: selectCarrier?.value || null,
        carrierName: selectCarrier?.label || '',
        listUnitMeasure: listUnitMeasure || [],
        unitMeasure: selectUnitMeasure?.value || null,
        unitMeasureCode: selectUnitMeasure?.value || null,
        unitMeasureName: selectUnitMeasure?.label || '',
      });
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;
        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE3771' /* Documento de Entrada Manual */),
            `${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1638' /* Ocorreu uma falha de comunicação com o servidor. */),
            'top-right',
          );
        }
      }
    }
  };

  getProductsOptions = async () => {
    try {
      const dataOptions = await this.props.getManualRequestOptions();

      this.setState({
        listProduct: dataOptions?.products || null,
      });
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;
        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE3771' /* Documento de Entrada Manual */),
            `${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1638' /* Ocorreu uma falha de comunicação com o servidor. */),
            'top-right',
          );
        }
      }
    }
  };

  createManualRequest = async () => {
    const {
      branchCode, supplierCode, orderNumber, orderTypeCode, note, cfop, serie, specie, accessKey, canceled,
    } = this.state;

    const {
      carrierCode, licensePlate, expectedVolumes, postalCode, street, number, ibge,
      complement, district, city, state, country, deliveryDate,
    } = this.state;

    const {
      productsRequest,
    } = this.state;

    try {
      const newManualRequest = {
        branchCode,
        supplierCode,
        orderNumber,
        orderType: orderTypeCode,
        note,
        cfop,
        serie,
        specie,
        accessKey,
        canceled,
        carrierCode,
        licensePlate,
        expectedVolumes,
        postalCode,
        street,
        number,
        ibge,
        complement,
        district,
        city,
        state,
        country,
        deliveryDate,
        products: productsRequest,
      };

      const result = await this.props.createManualRequest(newManualRequest);

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE3771' /* Documento de Entrada Manual */),
          I18n.t('BEE1960' /* Erro ao gravar os dados */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE3771' /* Documento de Entrada Manual */),
          I18n.t('BEE2843' /* Requisição gerada com sucesso! */),
          'top-right',
        );

        this.setState({
          branchCode: '',
          branchName: '',
          supplierCode: '',
          supplierName: '',
          orderNumber: '',
          orderTypeCode: '',
          orderTypeName: '',
          cfop: '',
          specie: '',
          serie: '',
          accessKey: '',
          canceled: false,
          note: '',
          carrierCode: '',
          carrierName: '',
          licensePlate: '',
          expectedVolumes: '',
          postalCode: '',
          street: '',
          number: '',
          ibge: '',
          complement: '',
          district: '',
          city: '',
          state: '',
          country: '',
          deliveryDate: '',
          productCode: null,
          productName: '',
          supplierProductCode: '',
          quantity: 1,
          productDeliveryDate: '',
          unitMeasure: '',
          unitMeasureCode: '',
          unitMeasureName: '',
          purchaseRequest: '',
          purchaseOrder: '',
          installment: 1,
          crossDockingOrder: '',
          crossDockingQuantity: '',
          batchNumber: '',
          expirationDate: '',
          productNote: '',
          productsRequest: [],
        });
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details}`
          : `${error.code} - ${error.message}`;
        addNotification('danger', I18n.t('BEE3771' /* Documento de Entrada Manual */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE3771' /* Documento de Entrada Manual */),
          I18n.t('BEE1960' /* Erro ao gravar os dados */),
          'top-right',
        );
      }
    }
  };

  searchViaCep = async (postalCode) => {
    const keepOnlyNumber = (value) => value.replace(/\D/g, '');
    const address = await getAddressByCep(keepOnlyNumber(postalCode));

    if (address.erro) {
      await this.cleanAddress();
    } else {
      await this.setState({
        street: address.logradouro,
        ibge: address.ibge,
        number: '',
        complement: '',
        district: address.bairro,
        city: address.localidade,
        state: address.uf,
        country: I18n.t('BEE103' /* Brasil */),
      });
    }
  };

  cleanAddress = async () => {
    await this.setState({
      ibge: '',
      street: '',
      number: '',
      complement: '',
      district: '',
      city: '',
      state: '',
      country: '',
    });
  };

  validProcessFile = async () => {
    if (this.props.jsonCsv === null) {
      addNotification(
        'danger',
        I18n.t('BEE2509' /* Importação em massa */),
        I18n.t('BEE2511' /* Nenhum arquivo selecionado */),
        'top-right',
      );
    } else await this.processFile();
  };

  processFile = async () => {
    const { jsonCsv } = this.props;
    const inboundOrderErrors = await this.props.generateBulkImport(jsonCsv);
    await this.props.setJsonContent(inboundOrderErrors);
  };

  cancelBulkImport = () => {
    this.props.setStatusBulkImport(!this.props.showBulkImport);
    this.props.setJsonContent(null);
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const {
      branchCode,
      branchName,
      productsRequest,
      listSuppliers,
      supplierCode,
      supplierName,
      orderNumber,
      listOrderTypes,
      orderTypeCode,
      orderTypeName,
      serie,
      specie,
      accessKey,
      canceled,
      note,
      carrierCode,
      carrierName,
      licensePlate,
      expectedVolumes,
      cfop,
      postalCode,
      street,
      number,
      complement,
      district,
      city,
      state,
      country,
      deliveryDate,
      productCode,
      productName,
      productNote,
      supplierProductCode,
      quantity,
      productDeliveryDate,
      purchaseRequest,
      purchaseOrder,
      installment,
      crossDockingOrder,
      crossDockingQuantity,
      batchNumber,
      expirationDate,
      disableName,
      listProduct,
      listBranch,
      page,
      listCarriers,
      listUnitMeasure,
      unitMeasureCode,
      unitMeasureName,
      disableUnitMeasure,
    } = this.state;

    const { showBulkImport, jsonCsv = [] } = this.props;

    return (
      <>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1400' /* Movimentação */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE36' /* Recebimento */)}</li>
            <li className="breadcrumb-item active">
              {I18n.t('BEE3771' /* Documento de Entrada Manual */)}
            </li>
          </ol>
        </div>
        <div className="d-flex align-items-center">
          <h1 className="page-header mb-0">
            {I18n.t('BEE3771' /* Documento de Entrada Manual */)}
          </h1>
          <WikiHelp wikiPath={ROUTES.INBOUND_MANUAL_REQUEST_HELP} />
          <div className="ml-auto d-flex">
            <div>
              <button
                type="button"
                className="btn btn-success btn-sm btn-rounded pl-2"
                onClick={() => this.props.setStatusBulkImport(!showBulkImport)}
              >
                <i className="fa fa-link mr-1" />
                {I18n.t('BEE3920' /* Importar CSV */)}
              </button>
            </div>
          </div>
        </div>

        {
          this.props.showBulkImport ? (
            <>
              <div className="slideUpTransition">
                <div className="d-flex align-items-center mb-md-3 mb-2" />
                <div className="row">
                  <div className="col-xl-12">
                    <Panel>
                      <PanelHeader noButton />
                      <PanelBody>
                        <div className="row">
                          <div
                            style={{
                              justifyContent: 'space-evenly',
                              display: 'flex',
                              flex: 1,
                            }}
                          >
                            <ImportCaption
                              headers={[
                                { label: 'branchCode', key: 'branchCode' },
                                { label: 'supplierCode', key: 'supplierCode' },
                                { label: 'orderNumber', key: 'orderNumber' },
                                { label: 'orderType', key: 'orderType' },
                                { label: 'serie', key: 'serie' },
                                { label: 'specie', key: 'specie' },
                                { label: 'accessKey', key: 'accessKey' },
                                { label: 'canceled', key: 'canceled' },
                                { label: 'carrierCode', key: 'carrierCode' },
                                { label: 'licensePlate', key: 'licensePlate' },
                                { label: 'expectedVolumes', key: 'expectedVolumes' },
                                { label: 'cfop', key: 'cfop' },
                                { label: 'deliveryDate', key: 'deliveryDate' },
                                { label: 'postalCode', key: 'postalCode' },
                                { label: 'ibge', key: 'ibge' },
                                { label: 'street', key: 'street' },
                                { label: 'number', key: 'number' },
                                { label: 'complement', key: 'complement' },
                                { label: 'district', key: 'district' },
                                { label: 'city', key: 'city' },
                                { label: 'state', key: 'state' },
                                { label: 'country', key: 'country' },
                                { label: 'note', key: 'note' },
                                { label: 'lineNumber', key: 'lineNumber' },
                                { label: 'productCode', key: 'productCode' },
                                { label: 'supplierProductCode', key: 'supplierProductCode' },
                                { label: 'quantity', key: 'quantity' },
                                { label: 'productDeliveryDate', key: 'productDeliveryDate' },
                                { label: 'unitMeasure', key: 'unitMeasure' },
                                { label: 'purchaseRequest', key: 'purchaseRequest' },
                                { label: 'purchaseOrder', key: 'purchaseOrder' },
                                { label: 'installment', key: 'installment' },
                                { label: 'crossDockingOrder', key: 'crossDockingOrder' },
                                { label: 'crossDockingQuantity', key: 'crossDockingQuantity' },
                                { label: 'productNote', key: 'productNote' },
                                { label: 'batchNumber', key: 'batchNumber' },
                                { label: 'expirationDate', key: 'expirationDate' },
                              ]}
                              data={[
                                {
                                  branchCode: '1',
                                  supplierCode: '1',
                                  orderNumber: '1234567',
                                  orderType: '2',
                                  serie: '1',
                                  specie: '1',
                                  accessKey: '123456',
                                  canceled: 'nao',
                                  carrierCode: '1',
                                  licensePlate: 'ABC-1234',
                                  expectedVolumes: '1',
                                  cfop: '123456',
                                  deliveryDate: '31/08/2024',
                                  postalCode: '12345-678',
                                  ibge: '123456',
                                  street: 'Rua teste',
                                  number: '123',
                                  complement: 'Complemento',
                                  district: 'Bairro',
                                  city: 'Cidade',
                                  state: 'Estado',
                                  country: 'País',
                                  note: 'Observação geral',
                                  lineNumber: '10',
                                  productCode: '1',
                                  supplierProductCode: '123456',
                                  quantity: '10',
                                  productDeliveryDate: '31/08/2024',
                                  unitMeasure: 'UN',
                                  purchaseRequest: '123456',
                                  purchaseOrder: '123456',
                                  installment: '1',
                                  crossDocking: '123456',
                                  crossDockingQuantity: '10',
                                  productNote: 'Observação do item 1',
                                  batchNumber: '123456',
                                  expirationDate: '31/08/2024',
                                },
                              ]}
                              filename="ImportarDocumentoEntradaManual.csv"
                              legend={[
                                {
                                  nameField: 'branchCode',
                                  observationField: I18n.t('BEE409' /* Código da Filial */),
                                },
                                {
                                  nameField: 'supplierCode',
                                  observationField: I18n.t('BEE3919' /* Código do fornecedor */),
                                },
                                {
                                  nameField: 'orderNumber',
                                  observationField: I18n.t('BEE1124' /* Número do pedido */),
                                },
                                {
                                  nameField: 'orderType',
                                  observationField: I18n.t('BEE2273' /* Tipo do Documento */),
                                },
                                {
                                  nameField: 'serie',
                                  observationField: I18n.t('BEE403' /* Série */),
                                },
                                {
                                  nameField: 'specie',
                                  observationField: I18n.t('BEE1729' /* Espécie */),
                                },
                                {
                                  nameField: 'accessKey',
                                  observationField: I18n.t('BEE967' /* Chave de Acesso */),
                                },
                                {
                                  nameField: 'canceled',
                                  observationField: I18n.t('BEE3923' /* Nota fiscal cancelada */),
                                },
                                {
                                  nameField: 'carrierCode',
                                  observationField: I18n.t('BEE2272' /* Código da Transportadora */),
                                },
                                {
                                  nameField: 'licensePlate',
                                  observationField: I18n.t('BEE400' /* Placa do Veículo */),
                                },
                                {
                                  nameField: 'expectedVolumes',
                                  observationField: I18n.t('BEE1029' /* Volumes Esperados */),
                                },
                                {
                                  nameField: 'cfop',
                                  observationField: I18n.t('BEE1030' /* CFOP */),
                                },
                                {
                                  nameField: 'deliveryDate',
                                  observationField: I18n.t('BEE444' /* Data de Entrega */),
                                },
                                {
                                  nameField: 'postalCode',
                                  observationField: I18n.t('BEE1730' /* CEP */),
                                },
                                {
                                  nameField: 'ibge',
                                  observationField: I18n.t('BEE568' /* IBGE */),
                                },
                                {
                                  nameField: 'street',
                                  observationField: I18n.t('BEE121' /* Rua */),
                                },
                                {
                                  nameField: 'number',
                                  observationField: I18n.t('BEE123' /* Número */),
                                },
                                {
                                  nameField: 'complement',
                                  observationField: I18n.t('BEE125' /* Complemento */),
                                },
                                {
                                  nameField: 'district',
                                  observationField: I18n.t('BEE127' /* Bairro */),
                                },
                                {
                                  nameField: 'city',
                                  observationField: I18n.t('BEE53' /* Cidade */),
                                },
                                {
                                  nameField: 'state',
                                  observationField: I18n.t('BEE87' /* Estado */),
                                },
                                {
                                  nameField: 'country',
                                  observationField: I18n.t('BEE88' /* País */),
                                },
                                {
                                  nameField: 'note',
                                  observationField: I18n.t('BEE135' /* Observação */),
                                },
                                {
                                  nameField: 'lineNumber',
                                  observationField: I18n.t('BEE463' /* Linha */),
                                },
                                {
                                  nameField: 'productCode',
                                  observationField: I18n.t('BEE378' /* Código do Produto */),
                                },
                                {
                                  nameField: 'supplierProductCode',
                                  observationField: I18n.t('BEE3786' /* Código do Produto do Fornecedor */),
                                },
                                {
                                  nameField: 'quantity',
                                  observationField: I18n.t('BEE441' /* Quantidade */),
                                },
                                {
                                  nameField: 'productDeliveryDate',
                                  observationField: I18n.t('BEE3924' /* Data de entrega do produto */),
                                },
                                {
                                  nameField: 'unitMeasure',
                                  observationField: I18n.t('BEE1756' /* Unidade de Medida */),
                                },
                                {
                                  nameField: 'purchaseRequest',
                                  observationField: I18n.t('BEE3787' /* Solicitação de Compra */),
                                },
                                {
                                  nameField: 'purchaseOrder',
                                  observationField: I18n.t('BEE3789' /* Ordem de Compra */),
                                },
                                {
                                  nameField: 'installment',
                                  observationField: I18n.t('BEE3791' /* Parcela */),
                                },
                                {
                                  nameField: 'crossDockingOrder',
                                  observationField: I18n.t('BEE3794' /* Ordem de Cross-Docking */),
                                },
                                {
                                  nameField: 'crossDockingQuantity',
                                  observationField: I18n.t('BEE3796' /* Quantidade de Cross-Docking */),
                                },
                                {
                                  nameField: 'productNote',
                                  observationField: I18n.t('BEE3925' /* Observação do produto */),
                                },
                                {
                                  nameField: 'batchNumber',
                                  observationField: I18n.t('BEE1091' /* Número do lote */),
                                },
                                {
                                  nameField: 'expirationDate',
                                  observationField: I18n.t('BEE2398' /* Data de Validade */),
                                },
                              ]}
                            />
                            <DragAndDrop />
                          </div>
                        </div>
                      </PanelBody>
                      <PanelFooter className="text-right">
                        <OneClickButton
                          type="submit"
                          className="btn btn-white m-5"
                          style={{ paddingRight: '25px', paddingLeft: '25px' }}
                          onClick={this.cancelBulkImport}
                        >
                          {I18n.t('BEE99' /* Cancelar */)}
                        </OneClickButton>
                        <OneClickButton
                          type="submit"
                          style={{ paddingRight: '25px', paddingLeft: '25px' }}
                          className="btn btn-primary m-5"
                          onClick={() => this.validProcessFile()}
                        >
                          {I18n.t('BEE2496' /* Processar Arquivo */)}
                        </OneClickButton>
                      </PanelFooter>
                    </Panel>
                  </div>
                </div>
              </div>
              <div>
                <Table
                  downloadCSV
                  filterable
                  data={jsonCsv}
                  columns={this.csvPreviewTable}
                  expander
                  defaultPageSize={10}
                  defaultSorted={this.defaultSorted}
                  page={(page)
                    || ((!this.state.firstRun
                      && this.props.location.state
                      && this.props.location.state.dice
                      && this.props.location.state.dice.page)
                      ? this.props.location.state.dice.page : page)}
                  onPageChange={(Page) => ((Page >= 0) ? this.setState({ page: Page }) : this.setState({ page: 0 }))}
                  defaultFilterMethod={(filter, row) => {
                    const input = _.lowerCase(filter.value);
                    const value = _.lowerCase(row[filter.id]);
                    if (_.includes(value, input)) {
                      return true;
                    }
                  }}
                />
              </div>
            </>
          ) : (
            <div onSubmit={(e) => e.preventDefault()}>
              <PanelPage
                className="panel-with-tabs"
                noButton
                content={(
                  <>
                    <Nav tabs justified fill style={{ backgroundColor: 'lightgray' }}>
                      <NavItem>
                        <NavLink
                          className={this.state.activeTab === '1' ? 'active' : ''}
                          onClick={() => {
                            this.toggleTab('1');
                          }}
                        >
                          <span className="d-sm-none">Tab 1</span>
                          <span className="d-sm-block d-none">{I18n.t('BEE191' /* Geral */)}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={this.state.activeTab === '2' ? 'active' : ''}
                          onClick={() => {
                            this.toggleTab('2');
                          }}
                        >
                          <span className="d-sm-none">Tab 2</span>
                          <span className="d-sm-block d-none">{I18n.t('BEE3927' /* Transporte */)}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={this.state.activeTab === '3' ? 'active' : ''}
                          onClick={() => {
                            this.toggleTab('3');
                          }}
                        >
                          <span className="d-sm-none">Tab 3</span>
                          <span className="d-sm-block d-none">{I18n.t('BEE1377' /* Itens do Documento */)}</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab} style={{ marginBottom: '0' }}>
                      {/* General */}
                      <TabPane tabId="1">
                        <div className="row">
                          {/* branch */}
                          <div className="col-md-4">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createSelectDropDown(
                                  { value: branchCode, label: branchName },
                                  'branch',
                                  `${I18n.t('BEE145' /* Filial */)}:`,
                                  listBranch,
                                  undefined,
                                  undefined,
                                  ['col-form-label', '', ''],
                                  undefined,
                                  undefined,
                                  undefined,
                                  true,
                                ),
                              ])}
                            />
                          </div>
                          {/* supplier */}
                          <div className="col-md-3">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createSelectDropDown(
                                  { value: supplierCode, label: supplierName },
                                  'supplier',
                                  `${I18n.t('BEE1044' /* Fornecedor */)}:`,
                                  listSuppliers,
                                  undefined,
                                  undefined,
                                  ['col-form-label', '', ''],
                                  undefined,
                                  undefined,
                                  undefined,
                                  true,
                                ),
                              ])}
                            />
                          </div>
                          {/* orderNumber */}
                          <div className="col-md-3">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                // Número do pedido
                                formContext.createInput(
                                  orderNumber,
                                  'orderNumber',
                                  `${I18n.t('BEE1124' /* Número do pedido */)}:`,
                                  '',
                                  'text',
                                  true,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  orderNumber,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* orderType */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createSelectDropDown(
                                  { value: orderTypeCode, label: orderTypeName },
                                  'orderType',
                                  `${I18n.t('BEE2997' /* Tipo de Documento */)}:`,
                                  listOrderTypes,
                                  undefined,
                                  undefined,
                                  ['col-form-label', '', ''],
                                  undefined,
                                  undefined,
                                  undefined,
                                  true,
                                ),
                              ])}
                            />
                          </div>
                        </div>
                        <div className="row">
                          {/* cfop */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  cfop,
                                  'cfop',
                                  `${I18n.t('BEE1030' /* CFOP */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* specie */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createNumberFormat(
                                  specie,
                                  'specie',
                                  `${I18n.t('BEE1729' /* Espécie */)}:`,
                                  0,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                  true,
                                ),
                              ])}
                            />
                          </div>
                          {/* serie */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createNumberFormat(
                                  serie,
                                  'serie',
                                  `${I18n.t('BEE403' /* Série */)}:`,
                                  0,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                  true,
                                ),
                              ])}
                            />
                          </div>
                          {/* accessKey */}
                          <div className="col-md-4">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  accessKey,
                                  'accessKey',
                                  `${I18n.t('BEE967' /* Chave de Acesso */)}:`,
                                  '',
                                  'text',
                                  true,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* canceled */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createSelect(
                                  canceled,
                                  'canceled',
                                  `${I18n.t('BEE64' /* Cancelado */)}:`,
                                  [
                                    { value: false, label: 'Não' },
                                    { value: true, label: 'Sim' },
                                  ],
                                  undefined,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                        </div>
                        <div className="row">
                          {/* note */}
                          <div className="col-md-12">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createTextArea(
                                  note,
                                  'note',
                                  `${I18n.t('BEE135' /* Observação */)}:`,
                                  '',
                                  3,
                                  false,
                                  false,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                        </div>
                      </TabPane>
                      {/* Transportation */}
                      <TabPane tabId="2">
                        <div className="d-flex flex-wrap" style={{ gap: '1.3rem' }}>
                          {/* carrier */}
                          <div className="flex-column" style={{ flexBasis: '30%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createSelectDropDown(
                                  { value: carrierCode, label: carrierName },
                                  'carrier',
                                  `${I18n.t('BEE301' /* Transportadora */)}:`,
                                  listCarriers,
                                  undefined,
                                  undefined,
                                  ['col-form-label', '', ''],
                                  undefined,
                                  undefined,
                                  undefined,
                                  true,
                                ),
                              ])}
                            />
                          </div>
                          {/* licensePlate */}
                          <div className="flex-column" style={{ flexBasis: '15.5%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  licensePlate,
                                  'licensePlate',
                                  `${I18n.t('BEE400' /* Placa do Veículo */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* expectedVolumes */}
                          <div className="flex-column" style={{ flexBasis: '15.5%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createNumberFormat(
                                  expectedVolumes,
                                  'expectedVolumes',
                                  `${I18n.t('BEE1029' /* Volumes Esperados */)}:`,
                                  0,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                  true,
                                ),
                              ])}
                            />
                          </div>
                          {/* deliveryDate */}
                          <div className="flex-column" style={{ flexBasis: '12%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createDateInput(
                                  deliveryDate,
                                  'deliveryDate',
                                  `${I18n.t('BEE444' /* Data de Entrega */)}:`,
                                  undefined,
                                  undefined,
                                  ['col-form-label', 'div', 'div'],
                                  true,
                                ),
                              ])}
                            />
                          </div>
                          {/* postalCode */}
                          <div className="flex-column flex-grow-1" style={{ flexBasis: '12%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInputMask(
                                  postalCode,
                                  'postalCode',
                                  `${I18n.t('BEE1730' /* CEP */)}:`,
                                  '',
                                  '99999-999',
                                  true,
                                  false,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                        </div>
                        <div className="row">
                          {/* street */}
                          <div className="col-md-3">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  street,
                                  'street',
                                  `${I18n.t('BEE121' /* Rua */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* number */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  number,
                                  'number',
                                  `${I18n.t('BEE123' /* Número */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* complement */}
                          <div className="col-md-4">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  complement,
                                  'complement',
                                  `${I18n.t('BEE125' /* Complemento */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* district */}
                          <div className="col-md-3">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  district,
                                  'district',
                                  `${I18n.t('BEE127' /* Bairro */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                        </div>
                        <div className="row">
                          {/* city */}
                          <div className="col-md-3">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  city,
                                  'city',
                                  `${I18n.t('BEE53' /* Cidade */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* state */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  state,
                                  'state',
                                  `${I18n.t('BEE87' /* Estado */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* country */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  country,
                                  'country',
                                  `${I18n.t('BEE88' /* País */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                        </div>
                      </TabPane>
                      {/* Document Items */}
                      <TabPane tabId="3">
                        <div className="d-flex flex-wrap" style={{ gap: '1.3rem' }}>
                          {/* product */}
                          <div className="flex-column" style={{ flexBasis: '15.5%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              setFilterDrop={this.setFilterDrop}
                              inputs={(formContext) => ([
                                formContext.createSelectDropDownFilter(
                                  { code: productCode, label: productName },
                                  'product',
                                  `${I18n.t('BEE378' /* Código do Produto */)}:`,
                                  listProduct,
                                  false,
                                  ['div', 'div', 'p-2'],
                                  true,
                                ),
                              ])}
                            />
                          </div>
                          {/* productName */}
                          <div className="flex-column flex-grow-1">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  productName,
                                  'productName',
                                  `${I18n.t('BEE758' /* Descrição Produto */)}:`,
                                  '',
                                  'text',
                                  false,
                                  disableName,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* supplierProductCode */}
                          <div className="flex-column flex-grow-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  supplierProductCode,
                                  'supplierProductCode',
                                  `${I18n.t('BEE3786' /* Código do Produto do Fornecedor */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* unitMeasure */}
                          <div className="flex-column" style={{ flexBasis: '13%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                disableUnitMeasure
                                  ? formContext.createInput(
                                    unitMeasureCode,
                                    'unitMeasure',
                                    `${I18n.t('BEE3799' /* UN */)}:`,
                                    '',
                                    'text',
                                    true,
                                    disableUnitMeasure,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    ['div', 'col-form-label', 'p-2'],
                                  )
                                  : formContext.createSelectDropDown(
                                    { value: unitMeasureCode, label: unitMeasureName },
                                    'unitMeasure',
                                    `${I18n.t('BEE3799' /* UN */)}:`,
                                    listUnitMeasure,
                                    undefined,
                                    undefined,
                                    ['col-form-label', '', ''],
                                    disableUnitMeasure,
                                    undefined,
                                    undefined,
                                    true,
                                  ),
                              ])}
                            />
                          </div>
                          {/* quantity */}
                          <div className="flex-column" style={{ flexBasis: '10%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createNumberFormat(
                                  quantity,
                                  'quantity',
                                  `${I18n.t('BEE1688' /* Quantidade */)}:`,
                                  4,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                  true,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  this.props.fractionalQuantity,
                                ),
                              ])}
                            />
                          </div>
                          {/* productDeliveryDate */}
                          <div className="flex-column" style={{ flexBasis: '10%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createDateInput(
                                  productDeliveryDate,
                                  'productDeliveryDate',
                                  `${I18n.t('BEE444' /* Data de Entrega */)}:`,
                                  undefined,
                                  undefined,
                                  ['col-form-label', 'div', 'div'],
                                ),
                              ])}
                            />
                          </div>
                        </div>
                        <div className="row">
                          {/* purchaseRequest */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  purchaseRequest,
                                  'purchaseRequest',
                                  `${I18n.t('BEE3787' /* Solicitação de Compra */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* purchaseOrder */}
                          <div className="col-md-3">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  purchaseOrder,
                                  'purchaseOrder',
                                  `${I18n.t('BEE3789' /* Ordem de Compra */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* installment */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createNumberFormat(
                                  installment,
                                  'installment',
                                  `${I18n.t('BEE3791' /* Parcela */)}:`,
                                  0,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* crossDockingOrder */}
                          <div className="col-md-2">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  crossDockingOrder,
                                  'crossDockingOrder',
                                  `${I18n.t('BEE3794' /* Ordem de Cross-Docking */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* crossDockingQuantity */}
                          <div className="col-md-3">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  crossDockingQuantity,
                                  'crossDockingQuantity',
                                  `${I18n.t('BEE3796' /* Quantidade de Cross-Docking */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                        </div>
                        <div className="d-flex flex-wrap" style={{ gap: '1.3rem' }}>
                          {/* batchNumber */}
                          <div className="flex-column" style={{ flexBasis: '15.5%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createInput(
                                  batchNumber,
                                  'batchNumber',
                                  `${I18n.t('BEE1091' /* Número do lote */)}:`,
                                  '',
                                  'text',
                                  false,
                                  false,
                                  undefined,
                                  7,
                                  undefined,
                                  undefined,
                                  undefined,
                                  ['div', 'col-form-label', 'p-2'],
                                ),
                              ])}
                            />
                          </div>
                          {/* expirationDate */}
                          <div className="flex-column" style={{ flexBasis: '10%' }}>
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createDateInput(
                                  expirationDate,
                                  'expirationDate',
                                  `${I18n.t('BEE434' /* Data de Validade */)}:`,
                                  undefined,
                                  undefined,
                                  ['col-form-label', 'div', 'div'],
                                ),
                              ])}
                            />
                          </div>
                          {/* productNote */}
                          <div className="flex-column flex-grow-1">
                            <Form
                              noPanel
                              leftType
                              setValue={this.setValue}
                              setValueDrop={this.setValueDrop}
                              inputs={(formContext) => ([
                                formContext.createTextArea(
                                  productNote,
                                  'productNote',
                                  `${I18n.t('BEE135' /* Observação */)}:`,
                                  '',
                                  3,
                                  false,
                                  false,
                                  undefined,
                                  ['div', 'col-form-label', 'div'],
                                ),
                              ])}
                            />
                          </div>
                        </div>
                        <br />
                        <div style={{ marginBottom: '-15px' }}>
                          <OneClickButton
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={this.addProductsRequest}
                          >
                            {I18n.t('BEE359' /* Incluir Produto */)}
                          </OneClickButton>
                        </div>
                      </TabPane>
                    </TabContent>
                  </>
            )}
                footerContent={(
                  <>
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={this.createManualRequest}
                      disabled={!productsRequest.length}
                    >
                      {/* {I18n.t('BEE3771' /* Documento de Entrada Manual )} */}
                      {I18n.t('BEE138' /* Criar */)}
                    </OneClickButton>
                    <Table
                      expander
                      filterable
                      downButtonPosition
                      data={productsRequest}
                      totalDataLength={productsRequest.length}
                      columns={this.tableColumns}
                      pages={Math.ceil(productsRequest.length / this.pageSize)}
                      defaultSorted={this.defaultSorted}
                      defaultPageSize={this.pageSize}
                      defaultFilterMethod={(filter, row) => {
                        const input = _.lowerCase(filter.value);
                        const value = _.lowerCase(row[filter.id]);
                        if (_.includes(value, input)) {
                          return true;
                        }
                      }}
                    />

                  </>
            )}
              />
            </div>
          )
        }

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged && state.app.userLogged,
  showBulkImport: state.inboundOrders.showBulkImport,
  jsonCsv: state.bulkImport.jsonCsv || [],
  fileCsv: state.bulkImport.fileCsv,
  fractionalQuantity: state.app.permissionsCompany && state.app.permissionsCompany.fractionalQuantity,
});

const mapDispatchToProps = (dispatch) => ({
  getBranchesOptions: () => dispatch(getBranchesOptions()),
  getManualRequestOptions: () => dispatch(getManualRequestOptions()),
  getManualRequestOptionsProducts: (productFilter, loading) => dispatch(
    getManualRequestOptionsProducts(productFilter, loading),
  ),
  getSupplierOptions: () => dispatch(getSupplierOptions()),
  setStatusBulkImport: (showBulkImport) => dispatch(openBulkImportInboundOrder(showBulkImport)),
  generateBulkImport: (jsonCsv) => dispatch(bulkImportInboundOrder(jsonCsv)),
  setJsonContent: (jsonCsv) => dispatch(setJsonContent(jsonCsv)),
  createManualRequest: (newManualRequest) => dispatch(createManualRequest(newManualRequest)),
  getOrdersTypeOptions: () => dispatch(getOrdersTypeOptions()),
  getCarriersOptions: () => dispatch(getCarriersOptions()),
  getUnitsMeasureOptions: () => dispatch(getUnitsMeasureOptions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InboundOrderAdd));
